export default __webpack_public_path__ + "static/media/payment-image-02.c3152c99.png";